import { Flex } from '@cof/plastic-components';
import { styled } from 'styled-components';
import capOneSquareIcon from '../../../../assets/images/ob-accept-region-c1-icon.svg';
import lockIcon from '../../../../assets/images/lock-connection-black.svg';
import obAcceptRegionBankIcon from '../../../../assets/images/ob-accept-region-bank-icon.svg';

const ObBankIcon = styled.img`
    width: 57.43px;
    height: 57.43px;
`;

const CapOneSquare = styled.img`
    height: 57.43px;
`;

const LockIcon = styled.img`
    width: 57.43px;
    height: 57.43px;
`;

const ExperimentLockGraphicBlack = () => {
    const capOneImage = <CapOneSquare src={capOneSquareIcon} alt="" />;
    const bankIcon = <ObBankIcon src={obAcceptRegionBankIcon} alt="" />;
    return (
        <Flex
            height={'66px'}
            width={'228px'}
            alignItems={'center'}
            justifyContent={'center'}
            gap={'xs'}
            data-qa-id="OB-accept-region-j1-experiment-lock-graphic"
        >
            {capOneImage}
            <LockIcon src={lockIcon} alt="" />
            {bankIcon}
        </Flex>
    );
};

export default ExperimentLockGraphicBlack;
